<div class="dsgn-dscp st-dsgn-dscp">
  <div class="row">
    <div class="col-sm-12">
      <h3 class="cs-dsgn-ttl">Make a Signature</h3>
      <button class="closedialog cls-dlg-cls" mat-dialog-close="false" mat-button (click)="onclose()"><i
          class="material-icons">close</i></button>
    </div>
  </div>

  <mat-dialog-content>
    <mat-card-content>
      <canvas #sigPad width="400" height="200" (mousedown)="onMouseDown($event)"
        (mousemove)="onMouseMove($event)" (touchstart)="onTouchStart($event)"
        (touchmove)="onTouchMove($event)"></canvas>
      <br />
    </mat-card-content>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button class="clear-btn" (click)="clear()">Clear</button>
    <button mat-raised-button (click)="save()">Save</button>
  </mat-dialog-actions>
</div>